// import Slider from 'react-slick';
import OwlCarousel from 'react-owl-carousel';
import PropTypes from 'prop-types';

const internals = {};

internals.sliderOptions = {
    className: 'owl-theme',
    touchDrag: true,
    mouseDrag: true,
    lazyLoad: true,
    nav: false,
    items: 1,
    loop: true,
    responsive: {
        1024: {
            nav: true,
        }
    },
    navText: ["<i class='ic ic-button-arrow-prev'></i>", "<i class='ic ic-button-arrow-next'></i>"]
};

export default class InspirationSlider extends React.Component {
    static propTypes = {
        currentInspiration: PropTypes.object,
        receptionImages: PropTypes.array,
        ceremonyImages: PropTypes.array,
        hashListener: PropTypes.bool,
        hashInspirationName: PropTypes.string,
        hasDots: PropTypes.bool
    };
    static defaultProps = {
        hashListener: false,
        hasDots: false,
        hashInspirationName: '',
        currentInspiration: {},
        receptionImages: [],
        ceremonyImages: []
    };

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this._onSliderArrowClick();
    }

    _onSliderArrowClick = () => {
        $('.owl-next, .owl-prev').click( (e) => {
            const isReceptionSet = $(e.currentTarget).closest('.owl-carousel').find('.owl-stage').find('.owl-item.active').children().hasClass('reception-set');
            const stageBar = $(e.currentTarget).closest('.inspiration-card').find('.wedding-stage');
            const ceremonyOption = stageBar.find('.ceremony.option');
            const receptionOption = stageBar.find('.reception.option');

            if (isReceptionSet) {
                ceremonyOption.removeClass('active');
                receptionOption.addClass('active');
            } else {
                receptionOption.removeClass('active');
                ceremonyOption.addClass('active');
            }
        });
    };

    render() {
        const { currentInspiration, receptionImages, ceremonyImages, hashListener, hashInspirationName, hasDots } = this.props;
        const { name } = currentInspiration;

        return (
            <div className="inspiration-slider">
                <OwlCarousel {...internals.sliderOptions} dots={hasDots}>
                    { receptionImages.map((img, index) => {
                        return  (<div className="reception-set" key={`reception-${index}-${name}`}>
                                    <img data-hash={ hashListener ? `${hashInspirationName}-reception` : ''} className="owl-lazy" data-src={`${img}`} alt="" />
                                </div>);
                    })
                    }
                    { ceremonyImages.map((img, index) => {
                        return  (<div className="ceremony-set" key={`ceremony-${index}-${name}`}>
                                    <img data-hash={ hashListener ? `${hashInspirationName}-ceremony` : ''} className="owl-lazy" data-src={`${img}`} alt="" />
                                </div>);
                    })
                    }
                </OwlCarousel>
            </div>
        );
    }
}

